import ME from '../../Assets/Images/ME.png'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {VscFolderActive} from 'react-icons/vsc'


const About = () => {
  return (
    <section id='about'>
      <h2>About ME</h2>

      <div className='container grid grid-cols-[35%_50%] gap-[15%] max-[1024px]:grid-cols-1 max-[1024px]:gap-0'>

        <div className='w-[30rem] overflow-hidden rounded-[10px] max-[1024px]:w-auto max-[1024px]:pb-12 max-[1024px]:ml-28 max-[1024px]:!rounded-[10px] max-[600px]:w-80 max-[600px]:h-[30rem] max-[600px]:ml-8 max-[600px]:mb-8 max-[600px]:!rounded-[7px]'>
          <img src={ME} alt='about img'/>
        </div>


        <div className='max-[600px]:text-center'>
          <div className='grid grid-cols-3 gap-6 max-[600px]:grid-cols-2 max-[600px]:gap-4'>
            <article className='bg-bg-variant border border-transparent rounded-2xl p-8 text-center hover:bg-transparent hover:border-primary-variant hover:cursor-default'>
              <FaAward className='text-primary text-2xl mb-4'/>
              <h5 className='text-[0.95rem]'>Experience</h5>
              <small className='text-[0.7rem] text-light'>9+ Years</small>
            </article>

            <article className='bg-bg-variant border border-transparent rounded-2xl p-8 text-center hover:bg-transparent hover:border-primary-variant hover:cursor-default'>
              <FiUsers className='text-primary text-2xl mb-4'/>
              <h5 className='text-[0.95rem]'>Clients</h5>
              <small className='text-[0.7rem] text-light'>50+ Worldwide</small>
            </article>

            <article className='bg-bg-variant border border-transparent rounded-2xl p-8 text-center hover:bg-transparent hover:border-primary-variant hover:cursor-default'>
              <VscFolderActive className='text-primary text-2xl mb-4'/>
              <h5 className='text-[0.95rem]'>Projects</h5>
              <small className='text-[0.7rem] text-light'>45+ completed Projects</small>
            </article>
          </div>
          <p className='my-8 mb-[2.6rem] text-light max-[1024px]:my-4 max-[1024px]:mb-6 max-[600px]:mt-6 max-[600px]:mb-0'>
          Highly dedicated, disciplined and versatile young man with bias for action and a dynamic ability to fit in any work
          environment. Dedicated, loyal and dependable; strives to exceed expectation with service that is second-to-none.
          Possesses effective communication, refined leadership and dynamic people management skills with a poise for
          excellence in different work environments. Tech-savvy; has an incredible understanding of modern technology. A
          quick learner who is able to handle complex situations in a skilled and logical manner by aligning with
          organizational goals and objectives.
          Currently seeking an exciting opportunity where a combination of entrepreneurial drive and ownership mindset is
          encouraged; leveraging skills to contribute own quota to overall organizational growth.
          </p>

          <a href='#contact' className='btn btn-primary'>Contact</a>
        </div>
      </div>
    </section>
  )
}

export default About
